import {
  API_UNAVAILABLE_MESSAGE,
  CLOCK_SKEW_MESSAGE,
  errorKind,
  errorMessage,
  isApiError,
} from '@/lib/errors'

export interface RouteErrorDescription {
  title: string
  description: string
  /** Troca o ícone de alerta por um relógio. */
  clock?: boolean
  /** Mensagem original de um erro de render, mostrada só em "Detalhes técnicos". */
  technical: string | null
}

/**
 * Título e texto do ``ErrorPanel`` para um erro que derrubou a rota. Erro da
 * API ganha texto por tipo; erro de render (bug) ganha texto genérico, e a
 * mensagem crua fica guardada em ``technical``.
 */
export function describeRouteError(err: unknown): RouteErrorDescription {
  switch (errorKind(err)) {
    // Antes do 401 genérico: aqui a sessão está boa, quem errou foi o relógio
    // do servidor, e "faça login novamente" mandaria o usuário para um laço.
    case 'clock_skew':
      return {
        title: 'Relógio do servidor atrasado',
        description: CLOCK_SKEW_MESSAGE,
        clock: true,
        technical: null,
      }
    case 'network':
    case 'unavailable':
      return { title: 'Prism em manutenção', description: API_UNAVAILABLE_MESSAGE, technical: null }
    case 'server':
      return {
        title: 'Erro no servidor',
        description:
          'Algo quebrou do lado do Prism. Tente novamente — se persistir, reporte com o identificador abaixo.',
        technical: null,
      }
    case 'auth':
      return { title: 'Sessão expirada', description: 'Faça login novamente para continuar.', technical: null }
    case 'forbidden':
      return {
        title: 'Acesso negado',
        description: 'Sua conta não tem permissão para essa ação.',
        technical: null,
      }
    case 'not_found':
      return { title: 'Não encontrado', description: errorMessage(err), technical: null }
    case 'validation':
      return { title: 'Dados inválidos', description: errorMessage(err), technical: null }
    case 'rate_limit':
      return {
        title: 'Muitas requisições',
        description: 'Aguarde alguns segundos e tente novamente.',
        technical: null,
      }
    default:
      break
  }
  if (isApiError(err)) {
    return {
      title: err.problem?.title ?? 'Erro inesperado',
      description: errorMessage(err),
      technical: null,
    }
  }
  const technical = err instanceof Error ? err.message : typeof err === 'string' ? err : null
  return {
    title: 'Erro inesperado',
    description: 'Algo deu errado ao montar esta tela.',
    technical: technical !== '' ? technical : null,
  }
}
